import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Router } from "./Components/Router";
import { AlertProvider } from "./context/AlertContext";
import { AuthProvider } from "./context/AuthContext";
import { LayersProvider } from "./context/LayersContext";
import { RulerModalProvider } from "./context/RulerContext";
import { ImportedLayersProvider } from "./context/ImportedLayersContext";
import { DgcChartProvider } from "./context/DgcChartContext";
import theme from "./global/styles/theme";
import { muiTheme } from "./global/styles/muiTheme";
import "./global/styles/tailwind.output.css";
import { Toaster } from "sonner";

const App: React.FC = () => {
  return (
    <React.StrictMode>
      <MuiThemeProvider theme={muiTheme}>
        <CssBaseline />
        <ThemeProvider theme={theme}>
          <AlertProvider>
            <ImportedLayersProvider>
              <LayersProvider>
                <AuthProvider>
                  <RulerModalProvider>
                    <DgcChartProvider>
                      <BrowserRouter>
                        <Router />
                        <Toaster />
                      </BrowserRouter>
                    </DgcChartProvider>
                  </RulerModalProvider>
                </AuthProvider>
              </LayersProvider>
            </ImportedLayersProvider>
          </AlertProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </React.StrictMode>
  );
};

export default App;
